// Invite links (ADR 0019).
//
// The token lives in the link's fragment, `/invite#<token>`, which a browser
// never sends to a server, so it stays out of request logs, the CDN and the
// `Referer` header. Opening the link stashes the token for this tab and drops
// it from the address bar; signing in returns to the accept screen, which takes
// it back. A phone that must install the app first loses the tab, so the app
// also accepts a pasted link.

const STASH_KEY = 'sensing.invite';

/** Path of the screen that takes a stashed invite. */
export const ACCEPT_PATH = '/invite/accept' as const;

/** The link to send for an invite token, on this app's origin. */
export function inviteLink(token: string, origin: string = window.location.origin): string {
  return `${origin}/invite#${token}`;
}

/**
 * The token in a pasted invite link, or in a bare token. Anything that cannot
 * be one gives `null`.
 */
export function parseInviteToken(input: string): string | null {
  const text = input.trim();
  const hash = text.lastIndexOf('#');
  const token = hash >= 0 ? text.slice(hash + 1) : text;
  return /^[0-9a-f]{16,128}$/i.test(token) ? token : null;
}

/** Keep a token for this tab, across a sign-in redirect. */
export function stashInvite(token: string): void {
  try {
    sessionStorage.setItem(STASH_KEY, token);
  } catch {
    /* Storage unavailable: the accept screen offers to paste the link. */
  }
}

/** The token kept for this tab, if any. */
export function stashedInvite(): string | null {
  try {
    return sessionStorage.getItem(STASH_KEY);
  } catch {
    return null;
  }
}

/** Forget the kept token, once it was used or refused. */
export function clearStashedInvite(): void {
  try {
    sessionStorage.removeItem(STASH_KEY);
  } catch {
    /* Nothing to forget. */
  }
}
